import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp, ShieldAlert, ShieldCheck, Inbox, CreditCard, Bot, Clock, Award, Timer, Activity } from "lucide-react";

export default function Impact() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/impact").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="p-8 text-[13px]" style={{ color: "var(--text-muted)" }}>Loading metrics…</div>;
  const cards = [
    { k: "customer_signals_processed", label: "Customer signals processed", icon: Inbox, color: "var(--risk-waiting)" },
    { k: "cases_created", label: "Cases created", icon: Activity, color: "var(--risk-waiting)" },
    { k: "revenue_risk_cases_caught", label: "Revenue-risk cases caught", icon: ShieldAlert, color: "var(--risk-rev)" },
    { k: "trust_risk_cases_caught", label: "Trust-risk cases caught", icon: ShieldAlert, color: "var(--risk-rev)" },
    { k: "payment_subscription_issues_detected", label: "Payment / subscription issues detected", icon: CreditCard, color: "var(--risk-sla)" },
    { k: "ai_assisted_replies_drafted", label: "AI-assisted replies drafted", icon: Bot, color: "var(--risk-product)" },
    { k: "estimated_manual_triage_minutes_saved", label: "Manual triage minutes saved", icon: Timer, color: "var(--risk-healthy)", suffix: " min" },
    { k: "avg_first_response_time_minutes", label: "Avg first response time", icon: Clock, color: "var(--risk-healthy)", suffix: " min" },
    { k: "sla_breaches_prevented", label: "SLA breaches prevented", icon: ShieldCheck, color: "var(--risk-healthy)" },
    { k: "business_milestones_achieved", label: "Business milestones achieved", icon: Award, color: "var(--risk-product)" },
  ];
  return (
    <div className="px-4 py-5 md:px-8 md:py-6">
      <div className="mb-5">
        <div className="text-[11px] uppercase tracking-[0.18em] mb-1" style={{ color: "var(--text-muted)" }}>Business Impact</div>
        <h1 className="font-display text-[26px]">What Prioris protected today</h1>
        <p className="text-[13px] mt-1" style={{ color: "var(--text-secondary)" }}>
          The bottom-line proof of the platform — revenue safeguarded, trust restored, time recovered.
        </p>
      </div>
      <div className="grid grid-cols-12 gap-4" data-testid="impact-grid">
        {cards.map((c) => (
          <div key={c.k} className="card p-5 col-span-12 sm:col-span-6 lg:col-span-3" data-testid={`metric-${c.k}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="text-[11px] uppercase tracking-wider" style={{ color: "var(--text-muted)" }}>{c.label}</div>
              <c.icon size={14} style={{ color: c.color }} />
            </div>
            <div className="font-display text-[36px] leading-none">{d[c.k] ?? 0}{c.suffix || ""}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
